<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Received Suggesions</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                </v-toolbar>
                <br>
                <v-row dense>
                    <v-col cols="12" sm="1" md="1">
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-autocomplete dense outlined rounded item-value="id" item-text="standard"
                            :items="standard_list" v-model="std" label="Standard"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-autocomplete dense outlined rounded item-text="name" item-value="id" :items="category_list"
                            v-model="category" label="Category"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-autocomplete color="#0F2027" dense rounded v-model="querytype" :items="querytype_list"
                            item-text="name" item-value="id" label="Query Type" outlined />
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-text-field outlined dense type="date" v-model="from_date" label="From Date(inclusive)"
                            hint="From Date" rounded></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-text-field outlined dense type="date" v-model="to_date" label="To Date(exclusive)"
                            hint="To Date" rounded></v-text-field>
                    </v-col>
                </v-row>
                <v-row justify="center" dense>
                    <v-btn class="button mt-3" @click="getData()" :loading="loader">Proceed</v-btn>
                </v-row>
                <!-- {{ aws_path }} -->
                <v-col cols="12" sm="12" md="12">
                    <v-data-table :headers="headers" :items="bookList1" class="elevation-1 mytable" id="mytable" dense
                        v-if="feedbacklist != ''" @current-items="getFiltered">
                        <template v-slot:[`item.file`]="{ item }">
                            <span v-if="item.file_path != null">
                                <a class="p-2" :href="aws_path + item.file_path + item.file_name" target="blank">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-bind="attrs" v-on="on"> <v-icon
                                                    color="black">mdi-eye</v-icon></v-btn>
                                        </template>
                                        <span>
                                            View File!!!
                                        </span>
                                    </v-tooltip>
                                </a>
                            </span>
                            <span v-else>
                                --
                            </span>
                        </template>

                        <template v-slot:top class="pb-5">
                            <v-toolbar flat>
                                <v-btn color="success" outlined rounded
                                    @click="fnExcelReport('mytable', 'ResolveFeedback')">
                                    <v-icon left>mdi-export</v-icon>Export
                                </v-btn>
                            </v-toolbar>
                            <v-row dense justify="center" align="center">
                                <tr class="t-row">
                                    <div>
                                        <th>
                                            <v-row>
                                                <span v-for="header in headers" :key="header.text">
                                                    <span v-if="filters.hasOwnProperty(header.value)">
                                                        <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small
                                                            rounded dense outlined color="#0F2027" :label="header.text"
                                                            multiple clearable :items="columnValueList(header.value)"
                                                            v-model="filters[header.value]"></v-autocomplete>
                                                    </span>
                                                </span>
                                            </v-row>
                                        </th>
                                    </div>
                                </tr>
                            </v-row>
                        </template>
                        <template v-slot:[`item.read`]="{ item }">
                            <!-- v-if="item.querytype == 'Query'" -->
                            <div>
                                <span v-if="!item.is_read">
                                    <v-switch v-model="item.is_read" :color="item.is_read ? 'success' : 'primary'"
                                        @change="toggle(item.id, item.is_read)"></v-switch>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                                </span>
                            </div>
                            <!-- <div v-else>
                                <span v-if="!item.is_read">
                                    <v-switch v-model="item.is_read" :color="item.is_read ? 'success' : 'primary'"
                                        @change="toggle(item.id, item.is_read)" disabled></v-switch>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                                </span>
                            </div> -->

                        </template>
                        <template v-slot:[`item.edit_Remark`]="{ item }">
                            <div v-if="item.querytype == 'Query'">

                                <v-btn icon> <v-icon class="btn-css btn" color="primary"
                                        @click="editItem(item.id, item.remark, item)">mdi-eye</v-icon></v-btn>
                                <!-- <v-btn color="gray" @click="editItem(item.id,item.remark,item)" class="btn-css btn">
                                      <v-icon>mdi-plus-circle-outline</v-icon>
                                </v-btn> -->
                            </div>
                            <div v-else>
                                <v-btn icon disabled> <v-icon class="btn-css btn" color="primary"
                                        @click="editItem(item.id, item.remark, item)">mdi-eye</v-icon></v-btn>
                                <!-- <v-btn  disabled color="gray" @click="editItem(item.id,item.remark,item)" class="btn-css btn">
                                      <v-icon>mdi-plus-circle-outline</v-icon>
                                </v-btn> -->
                            </div>
                        </template>
                        <template v-slot:[`item.description`]="{ item }">
                            <v-btn color="success" icon dark @click="getDescription(item)" title="Description">
                                <v-icon> mdi-book-open</v-icon>
                            </v-btn>
                        </template>

                    </v-data-table>
                </v-col>
            </v-card>
            <v-dialog v-model="dialog" max-width="900px">
                <v-card v-if="item_edit.item != null">
                    <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title>{{ item_edit.item.title }}</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                    </v-toolbar>
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    <strong>Feedback File :</strong>
                                    <span v-if="item_edit.item.file_path != null">
                                        <a class="p-2"
                                            :href="aws_path + item_edit.item.file_path + item_edit.item.file_name"
                                            target="blank">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon v-bind="attrs" v-on="on"> <v-icon
                                                            color="black">mdi-eye</v-icon></v-btn>
                                                </template>
                                                <span>
                                                    View File!!!
                                                </span>
                                            </v-tooltip>
                                        </a>
                                    </span>
                                    <span v-else>
                                        --
                                    </span>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <strong>Feedback Date : </strong>
                                    {{ item_edit.item.feedback_date }}
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <strong>Feedback Category : </strong>
                                    {{ item_edit.item.category }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    <strong>Feedback Type : </strong>
                                    {{ item_edit.item.querytype }}
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <strong>User : </strong>
                                    {{ item_edit.item.user }}
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <strong>Standard : </strong>
                                    {{ item_edit.item.standard }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    <strong>Name : </strong>
                                    {{ item_edit.item.name }}
                                </v-col>
                            </v-row>

                            <v-col cols="12" sm="12" md="12">
                                <v-textarea outlined name="input-7-4" readonly filled
                                    v-model="item_edit.item.description" label="Description"></v-textarea>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <v-textarea outlined name="input-7-4" v-model="item_edit.remark"
                                    label="Enter Remark"></v-textarea>
                            </v-col>
                        </v-card>
                        <v-row dense justify="center">
                            <v-btn class="button" @click="dialog = false">Cancel</v-btn>
                            <v-btn class="button" @click="saveRemark">Save</v-btn>
                        </v-row>
                    </v-col>
                </v-card>
            </v-dialog>
            <v-dialog v-model="description_dialog" max-width="1200px">
                <v-card>
                    <br>
                    <v-card-text>
                        {{ show_description.description }}
                    </v-card-text>
                    <v-card-text v-if="is_principal">
                        <v-row>
                            <v-col style="font-weight: bold;" sm="12" md="4">Name : {{ show_description.name
                                }}</v-col>
                            <v-col style="font-weight: bold;" sm="12" md="4">User : {{ show_description.user
                                }}</v-col>
                            <v-col style="font-weight: bold;" sm="12" md="4">Standard : {{ show_description.standard
                                }}</v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-center"><v-btn color="warning"
                            @click="description_dialog = false">Close</v-btn></v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
    <!-- /. root div -->
</template>

<script>
import axios from "axios";
import * as XLSX from 'xlsx';
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
        description_dialog: false, show_description: "",
        from_date: null,
        to_date: null,
        color: "",
        snackbar: false,
        dialog: false,
        is_principal: false,
        leave_approval_status_list: [],

        from_date: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
        to_date: new Date().toISOString().slice(0, 10),

        // date_1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        // modal_1: false,
        // date_2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        // modal_2: false,
        // menu: false,
        // menu1: false,
        standard_list: [],
        std: null,
        category_list: null,
        category: null,
        snackbar_msg: null,
        aws_path: null,
        feedbacklist: [],
        filterArr: [],
        filters: {
            user: [],
            feedback_date: [],
            usertype: [],
            title: [],
            querytype: [],
        },
        headers: [
            { text: "Sr.No.", value: "srno" },
            { text: "Title", value: "title" },
            { text: "Description", value: "description" },
            { text: "User Type", value: "usertype" },
            { text: "Query Type", value: "querytype" },
            { text: "Category", value: "category" },
            { text: "Attachment", value: "file" },
            // { text: "Feedback Date", value: "feedback_date" },
            // { text: "Standard", value: "standard" },
            // { text: "User", value: "user" },
            // { text: "Name", value: "name" },
            { text: "Is Read ?", value: "read" },
            { text: "View", value: "edit_Remark" },
        ],
        item_edit: {
            remark: null,
            id: null,
            item: null,
        },
        loader: false,
        querytype_list: [], querytype: null,
    }),
    created() {
        this.aws_path = localStorage.getItem("awspath");
    },
    computed: {
        bookList1() {
            return this.feedbacklist.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
        },
    },
    methods: {
        fnExcelReport(id, name) {
            let tab_text = `<table border='1px'>
        <tr>
        <th>SR. No.</th>
        <th>Title</th>
        <th>Description</th>
        <th>User Type</th>
        <th>Query Type</th>
        <th>Category</th>
        <th>Attachment</th>
        <th>Is Read?</th>
        <th>View</th>
        </tr>`;

            this.feedbacklist.forEach((s, index) => {
                let attachment = s.file_path ? `<a href="${this.aws_path + s.file_path + s.file_name}" target="_blank">${this.aws_path + s.file_path + s.file_name}</a>` : '--';
                let readStatus = s.is_read ? 'Yes' : 'No';
                tab_text += `
        <tr>
            <td>${index + 1}</td>
            <td>${s.title}</td>
            <td>${s.description}</td>
            <td>${s.usertype}</td>
            <td>${s.querytype}</td>
            <td>${s.category}</td>
            <td>${attachment}</td>
            <td>${readStatus}</td>
            <td>${s.edit_Remark}</td>
        </tr>`;
            });

            tab_text += '</table>';

            const blob = new Blob([tab_text], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },

        getDescription(item) {
            this.show_description = item;
            this.description_dialog = true;
        },
        saveRemark() {
            const data = {
                id: this.item_edit.id,
                remark: this.item_edit.remark
            }
            axios
                .post("/Feedback/saveRemarkGenericFeedback", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Save Successfully...");
                        this.getData()
                        this.dialog = false
                    } else {
                        this.showSnackbar("#b71c1c", "Something Went Wrong...");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                })
                .finally(() => {
                    // 'use strict';
                });
        },
        editItem(id, remark, item) {
            this.item_edit.id = id
            this.item_edit.remark = remark
            this.item_edit.item = item
            this.dialog = true;
        },
        toggle(item, is_read) {
            const data = {
                id: item,
                is_read: is_read
            }
            axios
                .post("/Feedback/saveToggleGenericFeedback", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Save Successfully...");
                        this.getData()
                    } else {
                        this.showSnackbar("#b71c1c", "Something Went Wrong...");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                })
                .finally(() => {
                    // 'use strict';
                });
        },
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            return this.feedbacklist.map((d) => d[val]);
        },
        getData() {
            const data = {
                category: this.category,
                querytype: this.querytype,
                std: this.std,
                from_date: this.from_date,
                to_date: this.to_date,
            };
            this.loader = true
            this.feedbacklist = []
            // console.log(data)
            axios
                .post("/Feedback/getGenericResolvedFeedback", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.feedbacklist = res.data.feedbacklist;
                        this.is_principal = res.data.is_principal;
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.fmsg);
                    } else {
                        this.showSnackbar("#b71c1c", "Something Went Wrong...");
                    }
                    this.loader = false
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                    this.loader = false
                })
                .finally(() => {
                    // 'use strict';
                    this.loader = false
                });
        },

        onLoad() {
            axios
                .post("/Feedback/getGenericFeedbackCategory")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.standard_list = res.data.standard_list;
                        this.category_list = res.data.category_list;
                        this.querytype_list = res.data.querytype_list
                        // this.from_date = res.data.from_date;
                        // this.to_date = res.data.to_date;
                    } else {
                        this.showSnackbar("#b71c1c", "Something Went Wrong...");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                })
                .finally(() => {
                    // 'use strict';
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onLoad();
        this.aws_path = localStorage.getItem("awspath");
    },
    // watch: {
    //     from_date(val) {
    //         this.leave_from_date = this.formatDate(this.from_date);
    //     },
    //     to_date(val) {
    //         this.leave_to_date = this.formatDate(this.to_date);
    //     },
    // },
    created() {
        this.tenant = localStorage.getItem("EPS-tenant");
    },
};
</script>

<style scoped>
input[type="text"] {
    width: 100%;
    display: inline-block;
    border: 1px solid black;
    border-radius: 4px;
    box-sizing: border-box;
}

.select {
    width: 100%;
    display: inline-block;
    border: 1px solid black;
    border-radius: 4px;
    box-sizing: border-box;
}

input[type="date"] {
    width: 50%;
    display: inline-block;
    padding: 0.3rem;
    border: 1px solid gray;
    border-radius: 30px;
    box-sizing: border-box;
    padding-top: none !important;
    margin-top: none !important;
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
    font-size: small;
}

.table-head-background {
    background-color: #fcc96f;
    color: #fff;
    font-weight: 700;
}

.tc-title {
    background-image: linear-gradient(-90deg, #fcc96f, #fcb63c);
    color: #fff;
    font-weight: 700;
    margin: 0px !important;
    padding: 0px !important;
}

.text-left {
    font-size: 14px;
    font-weight: bold;
}

.text {
    color: blue;
    font-weight: 600;
    font-size: 14px;
}

.card-container {
    overflow-x: hidden;
    overflow: hidden;
}

/* .mytable1 {
  padding: 5px !important;
  } */
.mytable1>>>td {
    font-size: 15px;
    /* background-color: red; */
    /* padding: 3px; */
    height: 6px;
}
</style>
